import React from 'react';

import Button from '../Button';

const DefaultFallback = () => {
  const reloadPage = () => {
    window.location.reload();
  };

  return (
    <div className="awt-error-fallback-content">
      <h1>Something went wrong</h1>
      <p>
        Please check your network connection and{' '}
        <Button onClick={reloadPage} outlined>
          try again.
        </Button>
      </p>
    </div>
  );
};
interface SentryErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
class SentryErrorBoundary extends React.Component<
  SentryErrorBoundaryProps,
  { hasError: boolean }
> {
  state: { hasError: boolean };
  props: SentryErrorBoundaryProps;
  constructor(props: SentryErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error): { hasError: boolean } {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback || <DefaultFallback />;
    }

    return this.props.children;
  }
}

export default SentryErrorBoundary;
